import { render, staticRenderFns } from "./RegisterMore.vue?vue&type=template&id=d931eb36&"
import script from "./RegisterMore.vue?vue&type=script&lang=js&"
export * from "./RegisterMore.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports